/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/OrthoCoverage/Content/Downpayment/Type"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let planDetailsDownpaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'plan_details',
path: 'downpayment_type',
})
let constantData = 'FIXED'
let aggregateData = fromAggregate.equals(planDetailsDownpaymentTypeValueData, constantData)
let onClick = fromHelpers.useOnClickFixed({
  children,
  viewPath
  
})
let planDetailsDownpaymentTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'plan_details',
path: 'downpayment_type',
})
let constantData1 = 'PERCENTAGE'
let aggregateData1 = fromAggregate.equals(planDetailsDownpaymentTypeValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickPercentage({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Type.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-bxIu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="plan_details.downpayment_type"
 data="'FIXED'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
 text="Fixed"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="plan_details.downpayment_type"
 data="'PERCENTAGE'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData1}
 text="% of treatment fee"
/>
</div>
{children}
</React.Fragment>)
}